import React from "react"
import { Stack, Text } from "@chakra-ui/react"
import pluralize from "pluralize"
import PaymentSuccessful from "modals/PaymentSuccessful"

type Props = {
  quantity: number
  onHide: () => void
}

const PurchaseLeadRetrievalLicensesSuccess = ({ quantity, onHide }: Props) => (
  <PaymentSuccessful
    onHide={onHide}
    heading="Purchase Successful"
    body={(
      <Stack spacing={4}>
        <Text>
          <Text as="span" fontWeight="bold">
            {quantity} Lead Retrieval {pluralize("license", quantity)}
          </Text> {quantity === 1 ? "has" : "have"} been added to the event and{" "}
          {quantity === 1 ? "is" : "are"} ready to assign to exhibitors.
        </Text>
        <Text>
          The receipt is available in <Text as="span" fontWeight="bold">Account</Text> {">"} <Text as="span" fontWeight="bold">Plan & Billing</Text>.
        </Text>
      </Stack>
    )}
  />
)

export default PurchaseLeadRetrievalLicensesSuccess
